/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  text: string | undefined;
};

export const GoodsName: FcWithoutChildren<Props> = (props) => {
  const { text } = props;

  if (text === undefined) return null;

  return <h2 css={rootStyles}>{text}</h2>;
};

const rootStyles = css`
  color: #000;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
`;
